import dayjs from "dayjs"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import localeData from "dayjs/plugin/localeData"
import utc from "dayjs/plugin/utc"
import de from "dayjs/locale/de"
import fr from "dayjs/locale/fr"
import en from "dayjs/locale/en"
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'

//TODO: language handling has to be done
dayjs.extend(customParseFormat)
dayjs.extend(LocalizedFormat)
dayjs.extend(localeData)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale(de, null, true)

let utcOffset = 0
let timeZoneStr = "+00:00"
export const timeZone = ['Europe/Zurich', 'Europe/London', 'Europe/Kirov'][0]

export function setLocalTimezone (str) {
	utcOffset = str.substr(1).split(":").reduce((p, v, i) => p + parseInt(v) * ( ( 1 - i ) * 59 + 1 ), 0) * parseInt(str[0]+"1")
	timeZoneStr = str
}

export { dayjs as default, dayjs }

export function isSameDay (d1, d2) {
	return d1.format().substr(0, 10) == d2.format().substr(0, 10)
}

export function dayjsLocal (date) {
	if (typeof date == "string") {
		let parsedDate = dayjs(date, dayjs().localeData().longDateFormat('L'))
		let fixedDate = dayjs.tz(parsedDate.format('YYYY-MM-DD HH:mm'), timeZone)
		// let offset = parsedDate.utcOffset()
		// let fixedDate = parsedDate.tz(timeZone)
		// fixedDate = fixedDate.add(offset - fixedDate.utcOffset(), 'minute')
		return fixedDate
	} else if (dayjs.isDayjs(date)) {
		return date.tz(timeZone)
	} else {
		return dayjs(date).tz(timeZone)
	}
}
export function dayjsServer (date) {
	if (typeof date == "string") {
		if (/\+\d\d:\d\d$/.test(date)) {
			// case the server sends us a real date with Timezone we use this
			return dayjs(date)
		}
		// we force the timezone for the server
		return dayjs(date).format()
	}
}
export function formatServer (date) {
	return dayjs.tz(date.format('YYYY-MM-DD HH:mm'), timeZone).format() // UTC fmt
}
